/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-console */
export const debug =
  process.env.NODE_ENV === 'development'
    ? (...args: any[]) => {
        console?.log && console.log(new Date(), ...args);
      }
    : () => undefined;
